// "use strict"; 
// document.addEventListener("DOMContentLoaded", () => {
//     var adpPopup = {};
//     (function () {
//         var $this;
//         adpPopup = {
//             sPrevious: window.scrollY,
//             sDirection: "down",
//             init: function () {
//                 $this = this;
//                 $this.popupInit();
//                 $this.setupEvents();
//             },
//             setupEvents: function () {
//                 document.addEventListener("click", $this.handleButtonClick);
//                 document.addEventListener("keyup", $this.handleKeyPress);
//                 document.addEventListener("click", $this.handleOverlayClick);
//             },
//             popupInit: function () {
//                 document.addEventListener("scroll", $this.updateScrollDirection);
            
//                 var popups = document.querySelectorAll(".newsletter-popup");
            
//                 if (popups.length) {
//                     popups.forEach($this.setupPopup);
//                 }
//             },
            
//             updateScrollDirection: function () {
//                 let scrollCurrent = window.scrollY;
            
//                 $this.sDirection = scrollCurrent > $this.sPrevious ? "down" : "up";
            
//                 $this.sPrevious = scrollCurrent;
//             },
            
//             setupPopup: function (popup, index) {
            
//                 if (!$this.isAllowPopup(popup)) {
//                     return;
//                 }
            
//                 $this.openTriggerPopup(popup);
//             },
            
//             handleButtonClick: function (e) {
//                 const target = e.target;
//                 if (target.classList.contains("popup-close") || target.closest(".popup-close")) {
//                     $this.closePopup(target);
//                 }
//                 if (target.classList.contains("popup-accept") || target.closest(".popup-accept")) {
//                     $this.acceptPopup(target);
//                     $this.closePopup(target);
//                 }
//             },

//             handleKeyPress: function (e) {
//                 if (e.key === "Escape") {
//                     $this.closePopupsByAttribute("data-esc-close");
//                 }
//                 if (e.key === "F4") {
//                     $this.closePopupsByAttribute("data-f4-close");
//                 }
//             },

//             handleOverlayClick: function (e) {
//                 if (e.target.classList.contains("popup-overlay")) {
//                     $this.closePopupsByAttribute("data-overlay-close");
//                 }
//             },

//             setScrollDirection: function () {
//                 let scrollCurrent = window.scrollY;
//                 $this.sDirection = scrollCurrent > $this.sPrevious ? "down" : "up";
//                 $this.sPrevious = scrollCurrent;
//             },

//             closePopupsByAttribute: function (attribute) {
//                 var closeItems = document.querySelectorAll(`.popup-open[${attribute}="true"]`);
//                 closeItems.forEach($this.closePopup);
//             },

//             isAllowPopup: function (popup) {
//                 let limitDisplay = parseInt(popup.dataset.limitDisplay || 0);
//                 let limitDisplayCookie = parseInt($this.getCookie("popup-" + popup.dataset.id));
//                 return !(limitDisplay && limitDisplayCookie && limitDisplayCookie >= limitDisplay);
//             },

// 			openTriggerPopup: function (e) {
// 				let popup = e.originalEvent ? this : e;
			
// 				var trigger = popup.dataset.openTrigger;
			
// 				if ("delay" === trigger) {
// 					setTimeout(() => $this.openPopup(popup), popup.dataset.openDelayNumber * 1000);
// 				}
			
// 				if ("exit" === trigger) {
// 					var showExit = true;
// 					document.addEventListener("mousemove", function (event) {
// 						var scroll = window.pageYOffset || document.documentElement.scrollTop;
// 						if (event.pageY - scroll < 7 && showExit) {
// 							$this.openPopup(popup);
// 							showExit = false;
// 						}
// 					});
// 				}
			
// 				if ("scroll" === trigger) {
// 					var pointScrollType = popup.dataset.openScrollType;
// 					var pointScrollPosition = parseFloat(popup.dataset.openScrollPosition);
			
// 					document.addEventListener("scroll", () => {
// 						const scrollCondition =
// 							pointScrollType === "px" ? window.scrollY >= pointScrollPosition :
// 								$this.getScrollPercent() >= pointScrollPosition;
			
// 						if (scrollCondition) {
// 							$this.openPopup(popup);
// 						}
// 					});
// 				}
// 			},
			
// 			closeTriggerPopup: function (e) {
// 				let popup = e.originalEvent ? this : e;
			
// 				var trigger = popup.dataset.closeTrigger;
			
// 				if ("delay" === trigger) {
// 					setTimeout(() => $this.closePopup(popup), popup.dataset.closeDelayNumber * 1000);
// 				}
			
// 				if ("scroll" === trigger) {
// 					var pointScrollType = popup.dataset.closeScrollType;
// 					var pointScrollPosition = parseFloat(popup.dataset.closeScrollPosition);
// 					var initScrollPx = parseFloat(popup.dataset.initScrollPx);
// 					var initScrollPercent = parseFloat(popup.dataset.initScrollPercent);
			
// 					document.addEventListener("scroll", () => {
// 						const scrollConditionUp =
// 							pointScrollType === "px" && $this.sDirection === "up" &&
// 							window.scrollY < initScrollPx - pointScrollPosition;
			
// 						const scrollConditionDown =
// 							pointScrollType === "px" && $this.sDirection === "down" &&
// 							window.scrollY >= initScrollPx + pointScrollPosition;
			
// 						const scrollConditionPercentUp =
// 							pointScrollType === "%" && $this.sDirection === "up" &&
// 							$this.getScrollPercent() < initScrollPercent - pointScrollPosition;
			
// 						const scrollConditionPercentDown =
// 							pointScrollType === "%" && $this.sDirection === "down" &&
// 							$this.getScrollPercent() >= initScrollPercent + pointScrollPosition;
			
// 						if (scrollConditionUp || scrollConditionDown ||
// 							scrollConditionPercentUp || scrollConditionPercentDown) {
// 							$this.closePopup(popup);
// 						}
// 					});
// 				}
// 			},

// 			openPopup: function (popup) {
//                 if (null !== popup.getAttribute("data-body-scroll-disable") &&
//                     popup.getAttribute("data-body-scroll-disable") == 'true' && !popup.classList.contains("popup-already-opened")) {
//                     document.body.classList.add("popup-scroll-hidden");
//                 }

//                 let limit = parseInt($this.getCookie("popup-" + popup.dataset.id) || 0) + 1;

//                 // $this.setCookie("popup-" + popup.dataset.id, limit, {
//                 //     expires: popup.dataset.limitLifetime,
//                 // });

//                 if (popup.classList.contains("popup-open") ||
//                     popup.classList.contains("popup-already-opened")) {
//                     return;
//                 }

//                 popup.classList.add("popup-open");
//                 setTimeout(function() {
//                     popup.classList.add("popup_show");
//                 }, 400);

//                 popup.dataset.initScrollPx = window.scrollY;
//                 popup.dataset.initScrollPercent = $this.getScrollPercent();

//                 let animation = popup.dataset.openAnimation;

//                 $this.applyAnimation(popup, animation);

//                 $this.closeTriggerPopup(popup);
//             },
//             closePopup: function (event) {
//                 const targetElement = event.originalEvent ? this : event;
            
//                 const popup = targetElement.closest(".newsletter-popup");
            
//                 const exitAnimation = popup.dataset.exitAnimation;
            
//                 const animationCallback = () => {
//                     popup.classList.add("popup-already-opened");
//                     document.body.classList.add("popup-scroll-hidden-overhide");
//                     popup.classList.remove("popup-open");
//                     document.body.classList.remove("popup-scroll-hidden");
//                 };
            
//                 $this.applyAnimation(popup, exitAnimation, animationCallback);
//             },

//             acceptPopup: function (popup) { 
//                 $this.setCookie("popup-accept-" + popup.dataset.id, 1, {
//                     expires: 360,
//                 });
//             },


//             applyAnimation: function (popup, name, callback) {
//                 popup.classList.remove("popup_show");
//                 // setTimeout(function() {
//                     var overlayName = typeof callback === "function" ? "popupExitFade" : "popupOpenFade";
                
//                     popup.classList.remove("popup-animated", "popupOpenFade", "popupExitFade");
//                     popup.querySelector(".popup-wrap").classList.remove("popup-animated", "popupOpenSlide", "popupOpenFade", "popupExitSlide", "popupExitFade");
                    
//                     popup.nextSibling !== null ?
//                     popup.nextSibling.classList.add("popup-animated", overlayName) : '';
                
//                     popup.querySelector(".popup-wrap").classList.add("popup-animated", name);
                    
//                     ["webkitAnimationEnd", "mozAnimationEnd", "MSAnimationEnd", "oanimationend", "animationend"].forEach((event) => {
//                         popup.addEventListener(event, function () {
//                             popup.classList.remove("popup-animated", overlayName);
//                             popup.querySelector(".popup-wrap").classList.remove("popup-animated", name);
                
//                             if (typeof callback === "function") {
//                                 callback();
//                             }
                            
//                         }, { once: true });
//                     });
//                 // }, 800);
//             },

//             getCookie: function (name) {
//                 var matches = document.cookie.match(
//                     new RegExp(
//                         "(?:^|; )" +
//                         name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
//                         "=([^;]*)"
//                     )
//                 );
//                 return matches ? decodeURIComponent(matches[1]) : undefined;
//             },

//             setCookie: function (name, value, options) {
//                 options = options || {};
//                 options.path = options.path ?? "/";
            
//                 if (typeof options.expires === "number" && options.expires > 0) {
//                     options.expires = new Date(Date.now() + options.expires * 24 * 60 * 60 * 1000).toUTCString();
//                 }
            
//                 value = encodeURIComponent(value);
            
//                 var updatedCookie = `${name}=${value}`;
            
//                 for (var [propName, propValue] of Object.entries(options)) {
//                     if (typeof propValue !== "boolean") {
//                         updatedCookie += `; ${propName}=${propValue}`;
//                     } else if (propValue) {
//                         updatedCookie += `; ${propName}`;
//                     }
//                 }
            
//                 document.cookie = updatedCookie;
//             },

//             getScrollPercent: function () {
//                 var h = document.documentElement,
//                     b = document.body,
//                     st = "scrollTop",
//                     sh = "scrollHeight";
//                 return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
//             }

//         };
//     })();

//     adpPopup.init();

//     document.addEventListener("shopify:section:load", adpPopup.init);
//     document.addEventListener("shopify:section:unload", function () {
//         document.body.classList.remove("popup-scroll-hidden");
//     });
// });


class BZPopup extends HTMLElement {

    constructor() {
        super();
        this.sPrevious = window.scrollY;
        this.sDirection = "down";
        this._handleButtonClick = this._handleButtonClick.bind(this);
        this._handleKeyPress = this._handleKeyPress.bind(this);
        this._handleOverlayClick = this._handleOverlayClick.bind(this);
        this._updateScrollDirection = this._updateScrollDirection.bind(this);
    }

    connectedCallback() {
        this.init();
        document.addEventListener("shopify:section:load", () => this.init());
        document.addEventListener("shopify:section:unload", () => {
            document.body.classList.remove("popup-scroll-hidden");
        });
    }

    init() {
        this.popupInit();

        document.addEventListener("click", this._handleButtonClick);
        document.addEventListener("keyup", this._handleKeyPress);
        document.addEventListener("click", this._handleOverlayClick);
        document.addEventListener("scroll", this._updateScrollDirection);
    }

    popupInit() {
        if (!this.isAllowPopup()) return;
        this.openTrigger();
    }

    _updateScrollDirection() {
        let scrollCurrent = window.scrollY;
        this.sDirection = scrollCurrent > this.sPrevious ? "down" : "up";
        this.sPrevious = scrollCurrent;
    }

    /* -----------------------------------------------------
       TRIGGERS (open + close)
    ----------------------------------------------------- */

    openTrigger() {
        const trigger = this.dataset.openTrigger;

        if (trigger === "delay") {
            setTimeout(() => this.openPopup(), this.dataset.openDelayNumber * 1000);
        }

        if (trigger === "exit") {
            let showExit = true;
            document.addEventListener("mousemove", (event) => {
                const scroll = window.pageYOffset || document.documentElement.scrollTop;
                if (event.pageY - scroll < 7 && showExit) {
                    this.openPopup();
                    showExit = false;
                }
            });
        }

        if (trigger === "scroll") {
            const type = this.dataset.openScrollType;
            const pos = parseFloat(this.dataset.openScrollPosition);

            document.addEventListener("scroll", () => {
                const condition = type === "px"
                    ? window.scrollY >= pos
                    : this.getScrollPercent() >= pos;

                if (condition) this.openPopup();
            });
        }
    }

    closeTrigger() {
        const trigger = this.dataset.closeTrigger;

        if (trigger === "delay") {
            setTimeout(() => this.closePopup(), this.dataset.closeDelayNumber * 1000);
        }

        if (trigger === "scroll") {
            const type = this.dataset.closeScrollType;
            const pos = parseFloat(this.dataset.closeScrollPosition);
            const initPx = parseFloat(this.dataset.initScrollPx);
            const initPercent = parseFloat(this.dataset.initScrollPercent);

            document.addEventListener("scroll", () => {
                const upPx = type === "px" && this.sDirection === "up" &&
                    window.scrollY < initPx - pos;

                const downPx = type === "px" && this.sDirection === "down" &&
                    window.scrollY >= initPx + pos;

                const upPercent = type === "%" && this.sDirection === "up" &&
                    this.getScrollPercent() < initPercent - pos;

                const downPercent = type === "%" && this.sDirection === "down" &&
                    this.getScrollPercent() >= initPercent + pos;

                if (upPx || downPx || upPercent || downPercent) this.closePopup();
            });
        }
    }

    /* -----------------------------------------------------
       OPEN / CLOSE POPUP
    ----------------------------------------------------- */

    openPopup() {

        if (this.classList.contains("popup-open") ||
            this.classList.contains("popup-already-opened")) return;

        if (this.dataset.bodyScrollDisable === "true") {
            document.body.classList.add("popup-scroll-hidden");
        }

        this.classList.add("popup-open");

        // Dialog semantics; a popup with an overlay is modal and keeps keyboard focus inside
        const isModal = this.dataset.overlay === "true";
        const heading = this.querySelector(".popup-heading");
        this.setAttribute("role", "dialog");
        this.setAttribute("aria-modal", isModal ? "true" : "false");
        if (heading?.textContent.trim()) {
            if (!heading.id) heading.id = `PopupHeading-${this.dataset.id}`;
            this.setAttribute("aria-labelledby", heading.id);
        }

        setTimeout(() => {
            this.classList.add("popup_show");
            if (isModal && window.BzA11y?.isVisible(this)) {
                window.BzA11y.trapFocus(this, { delay: 20 });
            }
        }, 400);

        this.dataset.initScrollPx = window.scrollY;
        this.dataset.initScrollPercent = this.getScrollPercent();

        const animation = this.dataset.openAnimation;
        this.applyAnimation(animation);

        this.closeTrigger();
    }

    closePopup() {
        const animation = this.dataset.exitAnimation;

        window.BzA11y?.releaseFocus(this);
        const callback = () => {
            this.classList.add("popup-already-opened");
            document.body.classList.add("popup-scroll-hidden-overhide");
            this.classList.remove("popup-open");
            document.body.classList.remove("popup-scroll-hidden");
        };

        this.applyAnimation(animation, callback);
    }

    /* -----------------------------------------------------
       EVENTS
    ----------------------------------------------------- */

    _handleButtonClick = (e) => {
        const target = e.target;

        if (target.classList.contains("popup-close") || target.closest(".popup-close")) {
            this.closePopup();
        }
        if (target.classList.contains("popup-accept") || target.closest(".popup-accept")) {
            this.acceptPopup();
            this.closePopup();
        }
    }

    _handleKeyPress = (e) => {
        if (e.key === "Escape" && this.dataset.escClose === "true") {
            this.closePopup();
        }
        if (e.key === "F4" && this.dataset.f4Close === "true") {
            this.closePopup();
        }
    }

    _handleOverlayClick = (e) => {
        if (this.dataset.overlayClose === "true" && e.target.classList.contains("popup-overlay")) {
            this.closePopup();
        }
    }

    /* -----------------------------------------------------
       HELPERS
    ----------------------------------------------------- */

    isAllowPopup() {
        const limit = parseInt(this.dataset.limitDisplay || 0);
        const cookie = parseInt(this.getCookie("popup-" + this.dataset.id));

        return !(limit && cookie && cookie >= limit);
    }

    acceptPopup() {
        this.setCookie("popup-accept-" + this.dataset.id, 1, { expires: 360 });
    }

    applyAnimation(name, callback) {
        const wrap = this.querySelector(".popup-wrap");

        wrap.classList.add("popup-animated", name);

        wrap.addEventListener("animationend", () => {
            wrap.classList.remove("popup-animated", name);
            if (callback) callback();
        }, { once: true });
    }

    getScrollPercent() {
        const h = document.documentElement;
        const b = document.body;
        return ((h.scrollTop || b.scrollTop) /
            ((h.scrollHeight || b.scrollHeight) - h.clientHeight)) * 100;
    }

    /* -----------------------------------------------------
       COOKIE HELPERS
    ----------------------------------------------------- */

    getCookie(name) {
        let matches = document.cookie.match(
            new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)")
        );
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    setCookie(name, value, options = {}) {
        options.path = options.path ?? "/";

        if (typeof options.expires === "number" && options.expires > 0) {
            options.expires = new Date(Date.now() + options.expires * 864e5).toUTCString();
        }

        let updated = `${name}=${encodeURIComponent(value)}`;

        for (let [key, val] of Object.entries(options)) {
            updated += val === true ? `; ${key}` : `; ${key}=${val}`;
        }
        document.cookie = updated;
    }
}


customElements.define("bz-popup", BZPopup);